<template>
  <div>
    <details-modal
      :show="modals.meansOfTelecom"
      :current-operation="currentOperation"
      @cancel="closeModal"
      @create="createRecord"
      @delete="deleteRecord"
      @update="updateRecord"
    >
      <form>
        <fg-input v-model="meansOfTelecom.mocName" type="text" label="Nom" />
      </form>
      <p class="errorMessageInModal">{{ errorMessage }}</p>
    </details-modal>
    <div class="row">
      <div class="col-md-12">
        <crud-list
          ref="crudList"
          :fetch-data="fetchMeansOfTelecom"
          title="Moyens de communication"
          @create="create"
          @row-clicked="rowClicked"
        >
          <el-table-column label="Nom">
            <div slot-scope="slotScope">{{ slotScope.row.mocName }}&nbsp;</div>
          </el-table-column>
        </crud-list>
      </div>
    </div>
  </div>
</template>

<script>
import DetailsModal from './Modals/DetailsModal.vue';
import CrudList from './CrudList.vue';

export default {
  components: {
    CrudList,
    DetailsModal,
  },
  data() {
    return {
      modals: {
        meansOfTelecom: false,
      },
      currentOperation: {},
      meansOfTelecom: {},
      errorMessage: '',
    };
  },
  methods: {
    rowClicked(row) {
      this.currentOperation = 'edit';
      this.meansOfTelecom = { ...row };
      this.modals.meansOfTelecom = true;
    },
    fetchMeansOfTelecom(pageNumber, pageSize, searchText) {
      let url = process.env.VUE_APP_ANNUAIRE_API_URL;
      if (searchText) {
        url += `/meanoftelecomEntities/search/fulltext?name=${searchText}&page=${pageNumber -
          1}&size=${pageSize}`;
      } else {
        url += `/meanoftelecomEntities?page=${pageNumber - 1}&size=${pageSize}`;
      }
      return this.$http.get(url).then(response => ({
        records: response.data._embedded.meanoftelecomEntities
          ? response.data._embedded.meanoftelecomEntities
          : [],
        page: response.data.page,
      }));
    },
    deleteRecord() {
      this.errorMessage = 'Deleting...';
      this.$http
        .delete(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/meansoftelecom/${this.meansOfTelecom.mocId}`,
        )
        .then(response => {
          this.$refs.crudList.fetch();
          this.errorMessage = '';
          this.modals.meansOfTelecom = false;
        })
        .catch(error => {
          this.errorMessage = error.response.data.message;
        });
    },
    updateRecord() {
      this.errorMessage = 'Updating...';
      this.$http
        .patch(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/meansoftelecom/${this.meansOfTelecom.mocId}`,
          {
            mocName: this.meansOfTelecom.mocName,
          },
        )
        .then(response => {
          this.$refs.crudList.fetch();
          this.errorMessage = '';
          this.modals.meansOfTelecom = false;
        })
        .catch(error => {
          this.errorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    createRecord() {
      this.$http
        .post(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/meansoftelecom/${process.env.VUE_APP_ANNUAIRE_API_URL}`,
          {
            mocName: this.meansOfTelecom.mocName,
          },
        )
        .then(response => {
          this.$refs.crudList.fetch();
          this.errorMessage = '';
          this.modals.meansOfTelecom = false;
        })
        .catch(error => {
          this.errorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    create() {
      this.meansOfTelecom = {};
      this.currentOperation = 'create';
      this.modals.meansOfTelecom = true;
    },
    closeModal() {
      this.modals.meansOfTelecom = false;
      this.errorMessage = '';
    },
  },
};
</script>

<style scoped></style>
